export default __webpack_public_path__ + "static/media/title_zh_cn_sp.eb5d08c8.png";